import React, { useEffect, useState } from "react";
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import { Navigate, useLocation } from "react-router-dom";
import PageLoader from "./page-loader";

const EmailVerifiedInner = ({ component: Component }) => {
  const { isLoading, isAuthenticated, user, getIdTokenClaims } = useAuth0();
  const location = useLocation();
  const [isVerified, setIsVerified] = useState(null);

  useEffect(() => {
    const checkVerified = async () => {
      if (isLoading || !isAuthenticated) {
        return;
      }

      try {
        if (user?.email_verified === true) {
          setIsVerified(true);
          return;
        }

        const claims = await getIdTokenClaims({ ignoreCache: true });
        setIsVerified(Boolean(claims?.email_verified));
      } catch (_) {
        setIsVerified(false);
      }
    };

    checkVerified();
  }, [getIdTokenClaims, isAuthenticated, isLoading, user]);

  if (isLoading || isVerified === null) {
    return (
      <div className="page-layout">
        <PageLoader />
      </div>
    );
  }

  if (isVerified === false) {
    const returnTo = `${location.pathname}${location.search}`;
    return <Navigate to="/verify-email" replace state={{ returnTo }} />;
  }

  return <Component />;
};

export const EmailVerifiedGuard = ({ component }) => {
  const Component = withAuthenticationRequired(
    () => <EmailVerifiedInner component={component} />,
    {
      onRedirecting: () => (
        <div className="page-layout">
          <PageLoader />
        </div>
      ),
    }
  );

  return <Component />;
};
